import { useMemo } from 'react';
import {
    Pack,
    Sample,
    Repack,
    PackState,
    SampleState,
} from 'types/generated/graphql';

export const useTakenDownSample = (sample: Sample) => {
    const isTakenDown = useMemo(
        () =>
            sample &&
            (sample.sampleState === SampleState.TakenDown ||
                sample.pack?.packState === PackState.TakenDown),
        [sample],
    );

    return { isTakenDown };
};

export const useTakenDownPack = (item?: Pack | Repack) => {
    const isTakenDown = useMemo(
        () => !!item && item?.packState === PackState.TakenDown,
        [item],
    );

    return { isTakenDown };
};
